function initDropdownAriaExpanded() {
  if (!window.jQuery) return;
  var $ = window.jQuery;
  // Foundation omits aria-expanded on the <a> toggle for dropdown nav items.
  // Set it on init and keep it in sync with Foundation's show/hide events.
  // Events fire on the root menu <ul>; the submenu <ul> is passed as an argument.
  // Use a sub-namespace (.ariaSync) so repeated calls on Turbo navigation
  // safely replace handlers without stacking them.
  $('.is-dropdown-submenu-parent > a[aria-haspopup]').each(function() {
    if (!$(this).attr('aria-expanded')) {
      $(this).attr('aria-expanded', 'false');
    }
  });
  $(document).off('show.zf.dropdownMenu.ariaSync hide.zf.dropdownMenu.ariaSync');
  $(document).on('show.zf.dropdownMenu.ariaSync', function(e, $sub) {
    if ($sub && $sub.length) {
      $sub.closest('.is-dropdown-submenu-parent')
          .children('a[aria-haspopup]')
          .attr('aria-expanded', 'true');
    }
  });
  $(document).on('hide.zf.dropdownMenu.ariaSync', function() {
    // Foundation closes all open submenus together, so reset all open toggles.
    $('.is-dropdown-submenu-parent > a[aria-haspopup][aria-expanded="true"]')
        .attr('aria-expanded', 'false');
  });
}

function removeAriaControlsFromModalTriggers() {
  if (!window.jQuery) return;
  // Foundation adds aria-controls pointing to aria-hidden modals, which fails
  // ARIA validation because the referenced element is hidden. Remove it — the
  // aria-haspopup attribute alone is sufficient to convey the popup intent.
  window.jQuery('[data-open][aria-controls]').removeAttr('aria-controls');
}

function initLegacyFoundation() {
  if (window.jQuery && typeof window.jQuery.fn.foundation === "function") {
    window.jQuery(document).foundation();
  }
  if (window.jQuery) {
    window.jQuery(document).trigger("ready");
    initDropdownAriaExpanded();
    removeAriaControlsFromModalTriggers();
  }
}

document.addEventListener("DOMContentLoaded", initLegacyFoundation);
document.addEventListener("turbo:load", initLegacyFoundation);
document.addEventListener("turbolinks:load", initLegacyFoundation);
